let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eaPiu")).then(() => parcelRequire('5OblR'));